import { useState } from 'react';
import { useLang } from '../../../i18n/LanguageContext';

const activities = [
  {
    id: 2,
    typeEn: 'Psychic Vision', typeZh: '灵视觉',
    titleEn: 'Intuitive Sight & Communication Course', titleZh: '直觉洞察与沟通课程',
    date: 'May 19, 2026',
    location: 'Manchester, UK',
    image: 'https://public.readdy.ai/ai/img_res/08cd6d49d3dbbc30513239790ebe7f7f.jpg',
  },
  {
    id: 3,
    typeEn: 'Tarot Workshop', typeZh: '塔罗工作坊',
    titleEn: 'Professional Tarot Course Level II', titleZh: '专业塔罗课程（二阶）',
    date: 'July 4, 2026',
    location: 'Edinburgh, Scotland',
    image: 'https://readdy.ai/api/search-image?query=tarot%20card%20reading%20workshop%2C%20mystical%20tarot%20cards%20spread%20on%20purple%20velvet%20cloth%2C%20golden%20candlelight%2C%20magical%20atmosphere%2C%20professional%20tarot%20reading%20session%2C%20enchanting%20setting&width=800&height=600&seq=activity-tarot-workshop-003&orientation=landscape',
  },
  {
    id: 4,
    typeEn: 'Astrology Reading', typeZh: '占星解读',
    titleEn: 'Professional Astrology Course I', titleZh: '专业占星课程（一阶）',
    date: 'September 12, 2026',
    location: 'Bristol, UK',
    image: 'https://readdy.ai/api/search-image?query=astrology%20chart%20reading%20session%2C%20zodiac%20symbols%20and%20star%20maps%2C%20purple%20cosmic%20background%2C%20mystical%20astrological%20tools%2C%20celestial%20atmosphere%20with%20golden%20accents&width=800&height=600&seq=activity-astrology-004&orientation=landscape',
  },
  {
    id: 6,
    typeEn: 'Magic Herbalism', typeZh: '魔法草药',
    titleEn: 'Magic Herbalism Course Level 2 (With Electives)', titleZh: '魔法草药课程二阶（含选修）',
    date: 'January 15, 2027',
    location: 'York, UK',
    image: 'https://readdy.ai/api/search-image?query=magical%20herbalism%20workshop%20with%20dried%20herbs%20and%20botanical%20ingredients%2C%20vintage%20glass%20bottles%20with%20potions%2C%20green%20and%20purple%20mystical%20atmosphere%2C%20candles%20and%20ancient%20books%2C%20witchcraft%20apothecary%20aesthetic%2C%20moody%20enchanting%20lighting&width=800&height=600&seq=activity-magic-herb-006&orientation=landscape',
  },
];

export default function ActivitySlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { t } = useLang();

  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % activities.length);
  const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + activities.length) % activities.length);

  const getCardStyle = (index: number) => {
    const diff = (index - currentIndex + activities.length) % activities.length;
    if (diff === 0) return 'scale-100 opacity-100 z-30';
    if (diff === 1 || diff === activities.length - 1) return 'scale-90 opacity-50 z-20';
    return 'scale-75 opacity-0 z-10';
  };

  return (
    <section id="upcoming" className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-8">
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-white mb-3 sm:mb-4">{t('Course Preview', '课程及活动预告')}</h2>
          <p className="text-base sm:text-lg md:text-xl text-[#c8b6ff]">{t('Upcoming courses and mystical workshops', '即将开课，探索神秘智慧之旅')}</p>
        </div>

        <div className="relative h-[320px] sm:h-[420px] md:h-[500px] flex items-center justify-center">
          <button onClick={prevSlide} className="absolute left-0 sm:left-2 z-40 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm border border-[#d4af37]/30 rounded-full hover:bg-[#d4af37]/20 transition-all duration-300 cursor-pointer">
            <i className="ri-arrow-left-line text-xl sm:text-2xl text-[#d4af37]"></i>
          </button>

          <div className="relative w-full max-w-4xl h-full flex items-center justify-center px-12 sm:px-16">
            {activities.map((activity, index) => (
              <div
                key={activity.id}
                className={`absolute transition-all duration-500 ${getCardStyle(index)}`}
                style={{ transform: `translateX(${(index - currentIndex) * 100}px)` }}
              >
                <div className="w-[90vw] max-w-[600px] h-[260px] sm:h-[340px] md:h-[400px] rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl cursor-pointer group">
                  <div className="relative w-full h-full">
                    <img src={activity.image} alt={activity.titleEn} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#1a0b2e]/90 via-[#1a0b2e]/50 to-transparent"></div>
                    <div className="absolute top-4 sm:top-6 left-4 sm:left-6">
                      <span className="px-3 sm:px-4 py-1.5 sm:py-2 bg-[#d4af37] text-white text-xs sm:text-sm rounded-full font-medium">
                        {t(activity.typeEn, activity.typeZh)}
                      </span>
                    </div>
                    <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 right-4 sm:right-6">
                      <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-2 sm:mb-3 line-clamp-2">{t(activity.titleEn, activity.titleZh)}</h3>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button onClick={nextSlide} className="absolute right-0 sm:right-2 z-40 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm border border-[#d4af37]/30 rounded-full hover:bg-[#d4af37]/20 transition-all duration-300 cursor-pointer">
            <i className="ri-arrow-right-line text-xl sm:text-2xl text-[#d4af37]"></i>
          </button>
        </div>

        <div className="flex items-center justify-center space-x-2 sm:space-x-3 mt-8 sm:mt-12">
          {activities.map((_, index) => (
            <button key={index} onClick={() => setCurrentIndex(index)}
              className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all duration-300 cursor-pointer ${index === currentIndex ? 'bg-[#d4af37] shadow-lg shadow-[#d4af37]/50 w-6 sm:w-8' : 'bg-white/30 hover:bg-white/50'}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}